

 
import DescuentosTecnologias from "../newPages/homenew/DescuentosTecnologias";

function TecPagos() {
  return (
    <>
  <DescuentosTecnologias/>
    </>
  );
}

export default TecPagos;
